const prefix = '/sales';

export default [
    {
        path: prefix,
        redirect: '/dashboard/sales/commissions',
    },
    {
        path: `${prefix}/mdr-commissions`,
        redirect: '/dashboard/sales/commissions',
    },
];
